import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

// Capture the event at module load time — before React mounts
let _deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  _deferredPrompt = e;
});

const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const isInStandaloneMode = () =>
  window.navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

const InstallPrompt = () => {
  const [showAndroid, setShowAndroid] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    if (isInStandaloneMode()) return;
    if (localStorage.getItem("installPromptDismissed")) return;

    if (isIOS()) {
      setShowIOS(true);
      return;
    }

    if (_deferredPrompt) {
      setShowAndroid(true);
    } else {
      const handler = (e) => {
        e.preventDefault();
        _deferredPrompt = e;
        setShowAndroid(true);
      };
      window.addEventListener("beforeinstallprompt", handler);
      return () => window.removeEventListener("beforeinstallprompt", handler);
    }
  }, []);

  const handleInstall = async () => {
    if (!_deferredPrompt) return;
    _deferredPrompt.prompt();
    const { outcome } = await _deferredPrompt.userChoice;
    _deferredPrompt = null;
    setShowAndroid(false);
    if (outcome === "accepted") localStorage.setItem("installPromptDismissed", "1");
  };

  const handleDismiss = () => {
    setShowAndroid(false);
    setShowIOS(false);
    localStorage.setItem("installPromptDismissed", "1");
  };

  const bannerStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    borderTop: "1px solid #ddd",
    boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
    padding: "12px 16px",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    gap: 12,
  };

  const closeBtn = {
    marginLeft: "auto",
    background: "none",
    border: "none",
    fontSize: "1.2rem",
    color: "#888",
    cursor: "pointer",
    padding: "4px 8px",
  };

  const installBtn = {
    backgroundColor: "#3598DB",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 16px",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  };

  if (showAndroid)
    return (
      <div style={bannerStyle}>
        <img src="/logo192.png" alt="" width={40} height={40} style={{ borderRadius: 8 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: "0.95rem", color: "#222" }}>Install Andiamo Places</div>
          <div style={{ fontSize: "0.8rem", color: "#666" }}>Add to your home screen for the best experience</div>
        </div>
        <button style={installBtn} onClick={handleInstall}>Install</button>
        <button style={closeBtn} onClick={handleDismiss}>
          <FontAwesomeIcon icon={solid("xmark")} />
        </button>
      </div>
    );

  if (showIOS)
    return (
      <div style={bannerStyle}>
        <img src="/logo192.png" alt="" width={40} height={40} style={{ borderRadius: 8 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: "0.95rem", color: "#222" }}>Install Andiamo Places</div>
          <div style={{ fontSize: "0.8rem", color: "#666" }}>
            Tap <FontAwesomeIcon icon={solid("arrow-up-from-bracket")} /> then <strong>Add to Home Screen</strong>
          </div>
        </div>
        <button style={closeBtn} onClick={handleDismiss}>
          <FontAwesomeIcon icon={solid("xmark")} />
        </button>
      </div>
    );

  return null;
};

export default InstallPrompt;
